
import { fetchTranslate } from "@/lib/ai/ai-server";
import { useState } from "react";
import { useLanguage, getLanguageName } from "@/lib/lang";
import { Button } from "../ui/button";
import { Spinner } from "../ui/spinner";
import { cn } from "@/lib/utils";

export function AutoTranslateButton({
  original,
  replaceAll,
  className,
}: {
  original: string;
  replaceAll: (text:string)=>any;
  className?: string
}) {
  const [isTranslating, setIsTranslating] = useState(false);
  const languageCode = useLanguage();

  if (!original) return;

  return (
    <Button
      size="sm"
      variant="default"
      className={cn(" h-5 rounded-none px-1.5", className)}
      onClick={async () => {
        setIsTranslating(true);
        const result = await fetchTranslate(
          original,
          getLanguageName(languageCode),
        );
        if (result) replaceAll(result.translation);
        setIsTranslating(false);
      }}
      disabled={isTranslating}
    >
      {isTranslating ? <Spinner label="Translating..." /> : "Translate"}
    </Button>
  );
}